module.exports = __webpack_public_path__ + "static/porkshoulder-8ced18f0d851c7f9642e8aa27079ccf4.jpg";